import React from 'react';
import { Tag } from 'antd';
import { formatUserCompetency, formatUserCompetencyList } from 'selectors/user.selectors';
import UserCompetencyInput from './input';

const config = {
  // List Table
  list: {
    // Table Columns
    showFilter: true,
    filterSettings: {
      reducerKey: 'competencyCollectionValues',
      placeholder: 'comptency details',
      themeName: 'competency',
      showClearButton: false,
      initCustomFilterValues: {
        ids: {
          contains: false,
          searchFields: ['competency__id__in'],
          searchValue: []
        }
      }
    },
    format: formatUserCompetencyList,
    columns: [
      {
        title: 'Competency',
        dataIndex: 'competency__name',
        width: '600px',
        sorter: true,
        defaultSortOrder: 'ascend',
        render: (text, record) => record.competency.name
      },
      {
        title: 'Type',
        dataIndex: 'competency__competency_type__name',
        width: '300px',
        align: 'center',
        sorter: true,
        render: (text, record) => record.competency.competency_type.name
      },
      {
        title: 'Code',
        dataIndex: 'competency__lms_code',
        width: '200px',
        align: 'center',
        sorter: true,
        render: (text, record) => record.competency.lms_code
      },
      {
        title: 'Scheduled',
        dataIndex: 'scheduled',
        width: '300px',
        align: 'center',
        sorter: true,
        render: (text, record) => (record.scheduled && record.scheduled.isValid() ? record.scheduled.format('DD-MM-YYYY') : 'N/A')
      },
      {
        title: 'Awarded Date',
        dataIndex: 'awarded_date',
        width: '380px',
        align: 'center',
        sorter: true,
        render: (text, record) => (record.awarded_date && record.awarded_date.isValid() ? record.awarded_date.format('DD-MM-YYYY') : 'N/A')
      },
      {
        title: 'Expiry Date',
        dataIndex: 'expiry_date',
        width: '300px',
        align: 'center',
        sorter: true,
        render: (text, record, index) => (
          <Tag
            color={record.expiry_flag}
            key={index}
          >
            {record.expiry_date && record.expiry_date.isValid() ? record.expiry_date.format('DD-MM-YYYY') : 'Never'}
          </Tag>
        )
      },
      {
        title: 'Assessor',
        dataIndex: 'assessor',
        width: '300px',
        sorter: true
      }
    ],
    // Deleting
    confirmMessage: () => (
      <div>
        <p>
          Are you sure you wish to delete the competency ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'competency__name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      competency__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['competency__name'],
        searchValue: ''
      },
      assessor: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['assessor'],
        searchValue: ''
      },
      competency__lms_code: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['competency__lms_code'],
        searchValue: ''
      }
    },
    // General
    title: 'Competencies',
    commands: {
      showDelete: false,
      showAdd: false
    }
  },
  // Detail Screen
  detail: {
    // General
    format: formatUserCompetency,
    emptyMessage: 'Please select a Record',
    title: 'Competency',
    component: props => (
      <UserCompetencyInput
        {...props}
        inputFormItemLayout={{
          inputLayout: {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 10 }
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 14 }
            }
          },
          row: {
            gutter: 16
          },
          col: {
            span: 12
          }
        }}
        title="Competency"
      />
    )
  }
};

export default config;
